export const findDecimal = (num: number) => {
  const fullNum = (Math.round(num * 100) / 100).toFixed(2);
  return Number((fullNum + '').split('.')[1]);
};
